"use client";
import { HomeServiceOtherType } from "@/types/global";
import Image from "next/image";
import Hyperlink from "../ui/hyperlink";

interface Props {
    data: HomeServiceOtherType;
    i?: number;
    onModalOpen?: (modalTitle?: string) => void;
}

const ServiceAreaCard = ({ data, onModalOpen }: Props) => {
    return (
        <div className="col-md-6 col-xl-4 d-flex">
            <div className="desilo-service-box6 bg-color-white move-anim h-100 d-flex flex-column w-100">
                <div className="h-100 d-flex flex-column">
                    <div className="service-icon">
                        <Image
                            height={52}
                            width={52}
                            src={data.icon}
                            alt="service-icon"
                        />
                    </div>
                    <div className="service-content h-100 d-flex flex-column justify-content-between">
                        <div>
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>
                        </div>
                        <div className="row row-padding-top">
                            <div className="col-12 text-left">
                                <Hyperlink
                                    variant="modal-pill"
                                    onModalOpen={onModalOpen}
                                    modalTitle={data.buttonText}
                                >
                                    {data.buttonText}
                                </Hyperlink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceAreaCard;
